import { useComponentInViewport } from 'core-lib/hooks/useComponentInViewport';
import { useEffect, useRef } from 'react';

import { LayoutPropType } from '../../../types/layout';
import { trackSectionViewedStoreV2 } from '../../../utils/events';
import ProductCard from '../../Cards/ProductCard';
import s from './GridScrollListing.module.scss';
import useStoreItemClick from '../../../hooks/useStoreItemClick';
import { Typography } from 'ui-v2/components/Typography';
import AnimatedImage from 'core-lib/components/AnimatedImage';

export const GridScrollListing = ({ data }: LayoutPropType) => {
  //const
  const rootRef = useRef();
  const isEventFired = useRef(false);
  const inViewPort = useComponentInViewport(rootRef, {
    threshold: 0.5,
  });
  const { handleItemClickWithDelegation } = useStoreItemClick();
  const CARDID = data.entityType;

  useEffect(() => {
    if (inViewPort && !isEventFired.current) {
      trackSectionViewedStoreV2('car_specific_widget');
      isEventFired.current = true;
    }
  }, [data?.title, inViewPort]);
  return (
    <div
      className={s.root}
      ref={rootRef}
      onClick={(e) =>
        handleItemClickWithDelegation(
          e,
          CARDID,
          data?.entityType,
          data?.data,
          'car_specific_widget'
        )
      }
    >
      <div
        className={s.wrapper}
        style={{
          backgroundImage: `url(${data?.backgroundImage})`,
        }}
      >
        <div className={s.head}>
          <AnimatedImage
            src={data?.metaData?.headingImage}
            className={s.icon}
            alt="heading image"
          />
          <Typography
            label={data?.title}
            variant="h_2_bold"
            color="on_dark_bg"
          />
          <Typography
            label={data?.subtitle}
            variant="body_3_medium"
            color="on_dark_bg"
          />
        </div>
        {data?.metaData?.listingOrder?.map((item, ind) => (
          <div key={ind} className={s.container}>
            {data?.data
              ?.slice(
                ind > 0 ? data?.metaData?.listingOrder[ind - 1] : 0,
                ind > 0 ? item + data?.metaData?.listingOrder[ind - 1] : item
              )
              .map((card, idx) => (
                <div key={card?.productSku} className={s.item}>
                  <ProductCard
                    product={card}
                    section="car_specific_widget"
                    position={3 * ind + idx}
                    id={CARDID}
                  />
                </div>
              ))}
          </div>
        ))}
      </div>
    </div>
  );
};
